module.exports = __webpack_public_path__ + "static/img/application9-2.6baebfa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application9-2.jpg
// module id = eAoR
// module chunks = 0